<template>

    <div>

        <span id="tooltip-target-create-provider">
            <b-button variant="info"
                @click=" createProvider "
                :disabled=" isDisabled || isLoading "
                class="d-flex align-items-center justify-content-between">

                <i :class=" iconClasses "></i>
                Create Provider in UPD
            </b-button>
        </span>
        <b-tooltip target="tooltip-target-create-provider" triggers="hover">
            {{ tooltipTitle }}
        </b-tooltip>
    </div>
</template>

<script>

    import LoadingToggles from '../../mixins/LoadingToggles';

    export default {

        mixins: [ LoadingToggles ],
        props: {

            providerdata : Object,
            isDisabled   : Boolean
        },
        data(){

            return {

                isLoading : false,
            }
        },
        computed: {

            tooltipTitle(){

                return ( this.isDisabled ? 'Perfect match already exists, will not create new provider' : 'Use the CareExcahnge details on the left-hand side to create a provider in the UPD' );
            }
        },
        methods: {

            createProvider(){

                this.errors = [];
                let form = new Form( this.providerdata );
                this.isLoading = true;
                form.post( `/business/upd_api/createProviderFor/${this.providerdata.id}` )
                    .then( () => { /* will reload page */ })
                    .catch( err => {

                        if( err.response.data && err.response.data.data ) err.response.data.data.map( err => err.Reason ).forEach( err => alerts.addMessage( 'error', err ) );
                    })
                    .finally( () => this.isLoading = false );
            }
        },
        mounted(){

        }
    }
</script>

<style>

</style>